/**
 * Centre Page — daily fee schedule popup.
 */
(function () {
	'use strict';

	function init() {
		var openBtn = document.querySelector('[data-fee-schedule-open]');
		var popup = document.getElementById('centrePageFeePopup');
		if (!openBtn || !popup) {
			return;
		}

		var closeBtns = popup.querySelectorAll('[data-fee-schedule-close], .close-popup');
		var lastFocused = null;

		function openPopup() {
			lastFocused = document.activeElement;
			popup.removeAttribute('hidden');
			popup.setAttribute('aria-hidden', 'false');
			popup.style.display = 'flex';
			document.body.classList.add('centre-page-fee-open');
			var closeBtn = popup.querySelector('.close-popup');
			if (closeBtn) {
				closeBtn.focus();
			}
		}

		function closePopup() {
			popup.setAttribute('hidden', '');
			popup.setAttribute('aria-hidden', 'true');
			popup.style.display = 'none';
			document.body.classList.remove('centre-page-fee-open');
			if (lastFocused && typeof lastFocused.focus === 'function') {
				lastFocused.focus();
			}
		}

		openBtn.addEventListener('click', function (e) {
			e.preventDefault();
			openPopup();
		});

		closeBtns.forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				closePopup();
			});
		});

		popup.addEventListener('click', function (e) {
			if (e.target === popup) {
				closePopup();
			}
		});

		document.addEventListener('keydown', function (e) {
			if ('Escape' === e.key && 'false' === popup.getAttribute('aria-hidden')) {
				closePopup();
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
